import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function initHighlightLayout3Slider() {
    const sliderElements = document.querySelectorAll('.js-highlight-layout3-slider');

    if (!sliderElements.length) return;

    sliderElements.forEach((sliderElement) => {
        const wrapper = sliderElement.parentElement;
        const paginationEl = wrapper.nextElementSibling;
        const prevEl = wrapper.querySelector('.c_swiper-highlightblock-prev');
        const nextEl = wrapper.querySelector('.c_swiper-highlightblock-next');

        let swiperInstance = null;

        function initSwiper() {
            if (window.innerWidth < 768 && !swiperInstance) {
                swiperInstance = new Swiper(sliderElement, {
                    modules: [Navigation, Pagination],
                    slidesPerView: 1.2,
                    spaceBetween: 13,
                    slidesOffsetAfter: 24,
                    loop: false,
                    pagination: {
                        el: paginationEl,
                        clickable: true,
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                });
            } else if (window.innerWidth >= 768 && swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        }

        initSwiper();
        window.addEventListener('resize', initSwiper);
    });
}
